// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"61":"08e9460b","147":"43202ce7","421":"c7714eec","488":"23f5eb9d","633":"5a69c561","666":"92ad0ae1","828":"dfa00158","936":"3f75234f","945":"527f4aaa"}[chunkId] + ".js";
};